import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { th } from 'date-fns/locale';
import { AntecedentesMedicosService } from 'src/app/services/antecedentes_medicos.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-antecedentes-medicos',
  templateUrl: './antecedentes-medicos.component.html',
  styleUrls: ['./antecedentes-medicos.component.css']
})
export class AntecedentesMedicosComponent implements OnInit {
  @Input() consulta: any = null;

  tiposAntecedentes: string[] = [
    'Alergias',
    'Patologías y/o antecedentes familiares',
    'Hospitalizaciones y/o Cirugías',
    'Diagnósticos anteriores',
    'Medicamentos de uso permanente',
    'Cirugías',
    'Hábitos'
  ];
  selectedTab: string = '';
  isLoading: boolean = true;

  @ViewChild('tabContainer', { static: false }) tabContainer!: ElementRef;

  // Modal simple (overlay)
  modalActual: string | null = null;

  usuario: any = {};
  open = {
    alergias: false,
    familiares: false,
    hospitalizaciones: false,
    patologias: false,
    medicamentos: false,
    habitos: false,
    cirugias: false,
  };

  public formSubmitted = false;

  // ===== Formularios =====
  public alergiaForm = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    alergia: ['', [Validators.required]],
    fecha_inicio: ['', [Validators.required]],
    severidad: ['', [Validators.required]],
    reaccion_producida: ['', [Validators.required]],
    ben_fil_all_id: ['']
  });

  public cusidForm = this.fb.group({
    use_id: ['']
  });

  public familiaForm = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    patologia: ['', [Validators.required]],
    relacion_familiar: ['', [Validators.required]],
    comentario: [''],
    ben_fil_fam_id: []
  });

  public hospitalizacionForm = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    motivo: ['', [Validators.required]],
    fecha_inicio: ['', [Validators.required]],
    fecha_fin: ['', [Validators.required]],
    comentario: [''],
    ben_file_hos_id: []
  }, { validators: this.rangoFechasValidator('fecha_inicio', 'fecha_fin') });


  public patologiasForm = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    nombre: ['', [Validators.required]],
    fecha_inicio: ['', [Validators.required]],
    comentario: [''],
    ben_fil_pat_id: []
  });

  /** FORMULARIO DE HÁBITOS (alineado con el template) */
  public habitosForm: FormGroup = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    id_habito: ['', [Validators.required]],
    id_frecuencia: ['', [Validators.required]],
    comentario: ['']
  });

  // 1. Dropdown “Duración – Unidad”
  duracionUnidades = [
    'Día(s)',
    'Semana(s)',
    'Mes(es)',
    'Hora(s)',
    'Dosis',
    'Indefinido'
  ];

  // 3. Dropdown “Frecuencia – Unidad”
  frecuenciaUnidades = [
    'Hora(s)',
    'Día(s)',
    'Semana(s)',
    'Mes(es)'
  ];

  // 4. Dropdown “Dosis – Unidad de medida”
  dosisUnidades = [
    'mg',
    'g',
    'mcg',
    'ml',
    'UI',
    'comprimido(s)',
    'cápsula(s)',
    'gota(s)',
    'puff(s)',
    'ampolla(s)',
    'sobre(s)',
    'unidad(es)'
  ];

  public medicamentosForm = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    medicamento: ['', [Validators.required]],
    fecha_inicio: ['', [Validators.required]],

    // campos que se ENVÍAN al backend (como antes)
    dosis: [''],
    frecuencia: [''],
    duracion: [''],

    // campos auxiliares para el front
    duracion_valor: ['', [Validators.required]],
    duracion_unidad: ['', [Validators.required]],

    frecuencia_veces: ['', [Validators.required]],   // “Frecuencia”
    frecuencia_cada: ['', [Validators.required]],    // “CADA Número”
    frecuencia_unidad: ['', [Validators.required]],  // “Unidad”

    dosis_valor: ['', [Validators.required]],
    dosis_unidad: ['', [Validators.required]],

    comentario: [''],
    ben_fil_med_id: ['']
  });


  public cirugiaForm = this.fb.group({
    ben_id: ['', [Validators.required]],
    med_con_id: [null],
    nombre_cirugia: ['', [Validators.required]],
    fecha_cirugia: ['', [Validators.required]],
    comentario: [''],
    nombre_medico: ['', [Validators.required]]
  })

  // flags agregar
  agregandoAlergia = false;
  agregandoFamiliar = false;
  agregandoHospitalizacion = false;
  agregandoPatologia = false;
  agregandoHabito = false;
  agregandoMedicamento = false;
  agregandoCirugia = false;

  // caches (opcional)
  alergiasGuardadas: any[] = [];
  familiaresGuardadas: any[] = [];
  hospitalizacionesGuardadas: any[] = [];
  patologiasGuardadas: any[] = [];
  medicamentosGuardadas: any[] = [];
  habitosGuardadas: any[] = [];
  cirugiasGuardadas: any[] = [];

  alergiaEdit: any = [];
  familiaEdit: any = [];
  hospitalizacionEdit: any = [];
  patologiaEdit: any = [];
  medicamentoEdit: any = [];
  habitoEdit: any = [];
  cirugiaEdit: any = [];

  // selección para eliminar (modal)
  antecedenteAEliminar: any = null;
  tipoAntecedenteAEliminar:
    | 'alergias'
    | 'familiares'
    | 'hospitalizaciones'
    | 'patologias'
    | 'medicamentos'
    | 'habitos'
    | 'cirugias'
    | null = null;

  // datos complementarios
  cus_id!: string;
  ben_id!: string;
  severidades: any[] = [];
  relacion: any[] = [];
  frecuency_list: any[] = [];

  // Estructura segura
  mis_antecedentes: any = {
    allergic: [],
    familiar: [],
    hospitalizations: [],
    pathology: [],
    medicine: [],
    habit: [],
    surgery: []
  };

  // HABITOS
  habitos_list: Array<{ hab_id: any; hab_name: string; disponible?: boolean }> = [];
  esVideollamada: boolean = false;

  constructor(
    private fb: FormBuilder,
    public _antecedentesMedicos: AntecedentesMedicosService,
    public generalServices: GeneralService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.url.subscribe(url => {
      const rutaActual = url.join('/');
      this.esVideollamada = rutaActual.includes('videoconsulta');
    });

    this.usuario = new EncriptacionService().getUserInfo();
    let use_id = this.usuario._id;

    this.resetVariables();

    if (this.consulta && this.consulta.user_id) {
      use_id = this.consulta.user_id;
    }

    this.cusidForm.controls['use_id'].setValue(use_id);
    this.isLoading = true;
    // 1) OBTENER ben_id y recién ahí cargar todo lo demás RELACIONADO
    this._antecedentesMedicos.traeBen_Id(this.cusidForm.value).subscribe((data: any) => {
      this.ben_id = data.info;

      // setear ben_id en formularios dependientes
      this.alergiaForm.controls['ben_id'].setValue(this.ben_id);
      this.familiaForm.controls['ben_id'].setValue(this.ben_id);
      this.hospitalizacionForm.controls['ben_id'].setValue(this.ben_id);
      this.patologiasForm.controls['ben_id'].setValue(this.ben_id);
      this.medicamentosForm.controls['ben_id'].setValue(this.ben_id);
      this.habitosForm.controls['ben_id'].setValue(this.ben_id);
      this.cirugiaForm.controls['ben_id'].setValue(this.ben_id);

      // 2) cargar catálogos y antecedentes AHORA que ya hay ben_id
      this.cargarCatalogosYAntecedentes();
    });

    // Catálogos que NO dependen de ben_id
    this._antecedentesMedicos.traeSeveridad().subscribe((data: any) => {
      this.severidades = data;
    });

    this._antecedentesMedicos.traeRelacion().subscribe((data: any) => {
      this.relacion = data;
    });
    // this.isLoading = false;

  }


  rangoFechasValidator(
    inicioKey = 'fecha_inicio',
    finKey = 'fecha_fin'
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const inicioCtrl = group.get(inicioKey);
      const finCtrl = group.get(finKey);
      if (!inicioCtrl || !finCtrl) return null;

      const inicio = inicioCtrl.value ? new Date(inicioCtrl.value) : null;
      const fin = finCtrl.value ? new Date(finCtrl.value) : null;

      // si falta alguna fecha, no marcar error de rango
      if (!inicio || !fin) return null;

      // normaliza sin hora (opcional)
      inicio.setHours(0, 0, 0, 0);
      fin.setHours(0, 0, 0, 0);

      const valido = inicio <= fin;
      // puedes poner el error a nivel grupo
      return valido ? null : { rangoFechas: true };
    };
  }

  /** Carga hábitos, frecuencias y antecedentes (dependen de ben_id) */
  private cargarCatalogosYAntecedentes() {
    // Frecuencias
    this._antecedentesMedicos.postListConFrecuency().subscribe((data: any) => {
      this.frecuency_list = data.frecuency || [];
    });

    // Antecedentes (incluye la lista de hábitos ya guardados)
    this._antecedentesMedicos.postListarAntecedentes(this.cusidForm.value).subscribe((data: any) => {
      this.mis_antecedentes = data || { habit: [] };
      // console.log(this.mis_antecedentes);
      this.cargarHabitos();
    });
  }

  /** Carga lista de hábitos disponibles desde el backend y marca disponibilidad en base a los ya guardados */
  private cargarHabitos() {
  this._antecedentesMedicos.postListConHabits(this.ben_id).subscribe((data: any) => {
    const backendHabits = data?.habist || data?.habits || data || [];

    // NO guardamos h.disponible, solo id y nombre
    this.habitos_list = (backendHabits as any[]).map((h: any) => ({
      hab_id: h.hab_id,
      hab_name: h.hab_name
    }));

    // Luego calculamos disponibilidad según antecedentes
    this.actualizarDisponibilidadHabitos();
    this.isLoading = false;
  });
}


  /** Marca como NO disponible los hábitos ya guardados por el beneficiario */
 private actualizarDisponibilidadHabitos() {
  const yaGuardados = new Set(
    (this.mis_antecedentes?.habit || [])
      .map((h: any) => h?.ben_fil_hab_hab_id ?? h?.hab_id)
      .filter((x: any) => x !== undefined && x !== null)
  );

  this.habitos_list = this.habitos_list.map(h => ({
    ...h,
    // disponible SOLO depende de si ya está guardado o no
    disponible: !yaGuardados.has(h.hab_id)
  }));
}


  toggle(section: keyof typeof this.open) {
    const willOpen = !this.open[section];
    Object.keys(this.open).forEach(k => (this.open[k as keyof typeof this.open] = false));
    this.open[section] = willOpen;
  }

  traeAntecedentes() {
    this._antecedentesMedicos.postListarAntecedentes(this.cusidForm.value).subscribe((data: any) => {
      this.mis_antecedentes = data;
      // Recalcular disponibilidad de hábitos por si se agregó/eliminó algo
      this.actualizarDisponibilidadHabitos();
    });
  }

  // ======= Utilidad validación reactiva (para errores en el template) =======
  isInvalid(ctrl: string): boolean {
    const c = this.habitosForm.get(ctrl);
    return !!(c && c.invalid && (c.dirty || c.touched));
  }

  // ===== Alergias =====
  abrirAgregarAlergia() { this.agregandoAlergia = true; }
  cancelarAgregarAlergia() { this.agregandoAlergia = false; }

  agregarAlergia() {
    if (this.alergiaForm.invalid) {
      this.alergiaForm.markAllAsTouched();
      return;
    }

    // Modal de carga
    Swal.fire({
      allowOutsideClick: false,
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">schedule</i> <br><br>' +
        ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 24px; text-align: center; color: #171994;" >Guardando alergia...</h1>',
      showConfirmButton: false
    });
    Swal.showLoading();

    this._antecedentesMedicos.creaAlergia(this.alergiaForm.value).subscribe(
      (resp: any) => {
        Swal.close();

        // Caso 1: el backend responde 200 con {status:false, message:'Alergia ya registrada'}
        const esDuplicada =
          (resp && resp.status === false) &&
          (typeof resp.message === 'string') &&
          /ya registrad|ya existe|duplicad/i.test(resp.message);

        if (esDuplicada) {
          Swal.fire({
            html:
              ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">info</i> <br><br>' +
              ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 22px; text-align: center; color: #171994;">Esta alergia ya existe</h1>' +
              ` <p style="font-family: Mulish; font-size: 16px; text-align: center; margin-top:10px;">${resp.message}</p>`,
            confirmButtonText: 'Entendido'
          });
          this.alergiaForm.reset({
            ben_id: this.ben_id,
            med_con_id: this.consulta?.med_con_id ?? null
          });
          this.agregandoAlergia = false;
          this.traeAntecedentes(); return;
        }
        Swal.fire({
          allowOutsideClick: false,
          html:
            ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 24px; text-align: center; color: #171994;" >Alergia agregada</h1>',
          showConfirmButton: false,
          timer: 1500
        });

        // Reset conservando IDs
        this.alergiaForm.reset({
          ben_id: this.ben_id,
          med_con_id: this.consulta?.med_con_id ?? null
        });
        this.agregandoAlergia = false;
        this.traeAntecedentes();
      },
      (err) => {
        // Caso 2: error HTTP (por ejemplo 409, 400, etc.)
        Swal.close();
        const msg = err?.error?.message || 'Ocurrió un problema al guardar la alergia.';
        const esDuplicadaHTTP = /ya registrada|ya existe|duplicad/i.test(msg);

        Swal.fire({
          icon: esDuplicadaHTTP ? 'warning' : 'error',
          html:
            ` <i class="material-icons" style="color:${esDuplicadaHTTP ? '#F39C12' : '#E74C3C'};font-size: 58px;margin: 20px 40px 10px;">${esDuplicadaHTTP ? 'report_problem' : 'error'}</i> <br><br>` +
            ` <h1 style="font-family: Mulish; font-weight: 800;font-size: 22px; text-align: center; color: #171994;">${esDuplicadaHTTP ? 'Esta alergia ya existe' : 'No se pudo guardar'}</h1>` +
            ` <p style="font-family: Mulish; font-size: 16px; text-align: center; margin-top:10px;">${msg}</p>`,
          confirmButtonText: 'Entendido'
        });
      }
    );
  }


  // ===== Familiares =====
  abrirAgregarFamiliar() { this.agregandoFamiliar = true; }
  cancelarAgregarFamiliar() { this.agregandoFamiliar = false; }

  crearAntecedenteFamiliar() {
    if (this.familiaForm.invalid) {
      this.familiaForm.markAllAsTouched();
      return;
    }
    Swal.fire({
      allowOutsideClick: false,
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">schedule</i> <br><br>' +
        ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 24px; text-align: center; color: #171994;" >Guardando antecedente familiar...</h1>',
      showConfirmButton: false
    });
    Swal.showLoading();

    this._antecedentesMedicos.creaAntecedenteFamiliar(this.familiaForm.value).subscribe(
      (resp: any) => {

        const esDuplicada =
          (resp && resp.message && /ya registrad|ya existe|duplicad/i.test(resp.message));
        if (esDuplicada) {
          Swal.fire({
            html:
              ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">info</i> <br><br>' +
              ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 22px; text-align: center; color: #171994;">Este antecedente familiar ya existe</h1>' +
              ` <p style="font-family: Mulish; font-size: 16px; text-align: center; margin-top:10px;">${resp.message}</p>`,
            confirmButtonText: 'Entendido'
          });
          this.familiaForm.reset({
            ben_id: this.ben_id,
            med_con_id: this.consulta?.med_con_id ?? null
          });
          this.agregandoFamiliar = false;
          this.traeAntecedentes(); return;
        }
        Swal.fire({
          allowOutsideClick: false,
          html:
            ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 24px; text-align: center; color: #171994;" >Antecedente familiar agregado</h1>',
          showConfirmButton: false,
          timer: 1500
        });
        this.familiaForm.reset({
          ben_id: this.ben_id,
          med_con_id: this.consulta?.med_con_id ?? null
        });
        this.agregandoFamiliar = false;
        this.traeAntecedentes();
      });
  }

  abrirAgregarHospitalizacion() { this.agregandoHospitalizacion = true; }
  cancelarAgregarHospitalizacion() { this.agregandoHospitalizacion = false; }

  crearHospitalizacion() {
    if (this.hospitalizacionForm.invalid) return;

    this.modalCargando();

    this._antecedentesMedicos.creaHospitalizacion(this.hospitalizacionForm.value)
      .subscribe(() => {
        Swal.fire({
          allowOutsideClick: true,
          html:
            ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;" >El antecedente se ha agregado exitosamente</h1>',
          showConfirmButton: false,
          timer: 2500
        });
        this.hospitalizacionForm.reset({
          ben_id: this.ben_id,
          med_con_id: this.consulta?.med_con_id ?? null
        });
        this.agregandoHospitalizacion = false;
        this.traeAntecedentes();
      });
  }

  abrirAgregarPatologia() { this.agregandoPatologia = true; }
  cancelarAgregarPatologia() { this.agregandoPatologia = false; }

  crearPatologia() {
    if (this.patologiasForm.invalid) return;

    this.modalCargando();

    this._antecedentesMedicos.creaPatologia(this.patologiasForm.value).subscribe(() => {
      Swal.fire({
        allowOutsideClick: true,
        html:
          ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
          ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;" >El antecedente se ha agregado exitosamente</h1>',
        showConfirmButton: false,
        timer: 2500
      });
      this.patologiasForm.reset({
        ben_id: this.ben_id,
        med_con_id: this.consulta?.med_con_id ?? null
      });
      this.agregandoPatologia = false;
      this.traeAntecedentes();
    });
  }

  abrirAgregarMedicamento() { this.agregandoMedicamento = true; }
  cancelarAgregarMedicamento() { this.agregandoMedicamento = false; }

  crearMedicamento() {
    // construir textos a partir de los campos auxiliares
    const v = this.medicamentosForm.value;

    const duracionTexto =
      v.duracion_valor && v.duracion_unidad
        ? `${v.duracion_valor} ${v.duracion_unidad}`
        : '';

    const frecuenciaTexto =
      v.frecuencia_veces && v.frecuencia_cada && v.frecuencia_unidad
        ? `${v.frecuencia_veces} cada ${v.frecuencia_cada} ${v.frecuencia_unidad}`
        : '';

    const dosisTexto =
      v.dosis_valor && v.dosis_unidad
        ? `${v.dosis_valor} ${v.dosis_unidad}`
        : '';

    // setear en los campos que van al backend
    this.medicamentosForm.patchValue({
      duracion: duracionTexto,
      frecuencia: frecuenciaTexto,
      dosis: dosisTexto
    });

    if (this.medicamentosForm.invalid) {
      this.medicamentosForm.markAllAsTouched();
      return;
    }

    this.modalCargando();

    this._antecedentesMedicos.creaMedicamento(this.medicamentosForm.value).subscribe(() => {
      Swal.fire({
        allowOutsideClick: true,
        html:
          ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
          ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;" >El antecedente se ha agregado exitosamente</h1>',
        showConfirmButton: false,
        timer: 2500
      });

      this.medicamentosForm.reset({
        ben_id: this.ben_id,
        med_con_id: this.consulta?.med_con_id ?? null
      });
      this.agregandoMedicamento = false;
      this.traeAntecedentes();
    });
  }


  // ===== HÁBITOS =====
  abrirAgregarHabito() { this.agregandoHabito = true; }
  cancelarAgregarHabito() { this.agregandoHabito = false; }

  crearHabito() {
    if (this.habitosForm.invalid) {
      this.habitosForm.markAllAsTouched();
      return;
    }

    // Completar med_con_id si aplica
    this.habitosForm.patchValue({
      med_con_id: this.consulta?.med_con_id ?? null
    });

    Swal.fire({
      allowOutsideClick: false,
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">info</i> <br><br>' +
        ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;" >Guardando hábito...</h1>',
      showConfirmButton: false
    });

    this._antecedentesMedicos.postCrearHabitos(this.habitosForm.value).subscribe(
      () => {
        Swal.fire({
          allowOutsideClick: true,
          html:
            ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 24px; text-align: center; color: #171994;" >Hábito agregado</h1>',
          showConfirmButton: false,
          timer: 1500
        });

        // reset del form conservando ben_id
        this.habitosForm.reset({
          ben_id: this.ben_id,
          med_con_id: this.consulta?.med_con_id ?? null,
          id_habito: '',
          id_frecuencia: '',
          comentario: ''
        });

        this.agregandoHabito = false;

        // Recargar antecedentes y volver a calcular disponibilidad
        this.traeAntecedentes();
        // También puedes volver a traer el catálogo por si backend ya descarta el elegido
        this.cargarHabitos();
      },
      () => Swal.close()
    );
  }

  abrirAgregarCirugia() { this.agregandoCirugia = true; }
  cancelarAgregarCirugia() { this.agregandoCirugia = false; }


  crearCirugia() {
    if (this.cirugiaForm.invalid) {
      this.cirugiaForm.markAllAsTouched();
      return;
    }

    this.cirugiaForm.patchValue({
      med_con_id: this.consulta?.med_con_id ?? null
    });
    Swal.fire({
      allowOutsideClick: false,
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">info</i> <br><br>' +
        ' <h1 style="font-family: Mulish; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;" >Guardando cirugia...</h1>',
      showConfirmButton: false
    });
    this._antecedentesMedicos.postCrearCirugia(this.cirugiaForm.value)
      .subscribe((data: any) => {
        Swal.fire({
          allowOutsideClick: false,
          html:
            ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;" >La cirugía se ha agregado exitosamente</h1> <br>' +
            ' <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;" ></p><br>',
          showConfirmButton: false,
          timer: 2500
        });
        this.cirugiaForm.reset({
          ben_id: this.ben_id,
          med_con_id: this.consulta?.med_con_id ?? null
        });
        this.agregandoCirugia = false;
        this.ngOnInit();
      }

      )

  }

  // ===== Eliminar (modal genérico) =====
  abrirModalEliminar(
    i: number,
    item: any,
    tipo:
      'alergias'
      | 'familiares'
      | 'hospitalizaciones'
      | 'patologias'
      | 'medicamentos'
      | 'habitos'
      | 'cirugias'
  ) {
    // Solo guardamos el ítem y el tipo, NO tocamos los formularios de creación
    this.antecedenteAEliminar = item;
    this.tipoAntecedenteAEliminar = tipo;
    this.modalActual = 'confirmacionEliminar';
  }

  eliminarAntecedente() {
    if (!this.antecedenteAEliminar || !this.tipoAntecedenteAEliminar) return;

    this.modalCargando();

    if (this.tipoAntecedenteAEliminar === 'alergias') {
      this._antecedentesMedicos.eliminaAlergia(this.antecedenteAEliminar).subscribe(() => {
        Swal.close(); this.cerrarModal(); this.traeAntecedentes();
      });
      return;
    }

    if (this.tipoAntecedenteAEliminar === 'familiares') {
      this._antecedentesMedicos.eliminaAntecedenteFamiliar(this.antecedenteAEliminar).subscribe(() => {
        Swal.close(); this.cerrarModal(); this.traeAntecedentes();
      });
      return;
    }

    if (this.tipoAntecedenteAEliminar === 'hospitalizaciones') {
      this._antecedentesMedicos.eliminaHospitalizacion(this.antecedenteAEliminar).subscribe(() => {
        Swal.close(); this.cerrarModal(); this.traeAntecedentes();
      });
      return;
    }

    if (this.tipoAntecedenteAEliminar === 'patologias') {
      this._antecedentesMedicos.eliminaPatologia(this.antecedenteAEliminar).subscribe(() => {
        Swal.close(); this.cerrarModal(); this.traeAntecedentes();
      });
      return;
    }

    if (this.tipoAntecedenteAEliminar === 'medicamentos') {
      this._antecedentesMedicos.eliminaMedicamento(this.antecedenteAEliminar).subscribe(() => {
        Swal.close(); this.cerrarModal(); this.traeAntecedentes();
      });
      return;
    }

   if (this.tipoAntecedenteAEliminar === 'habitos') {
  // Este ya estaba especial: usa id + ben_id
  this._antecedentesMedicos.postEliminarHabito(
    this.antecedenteAEliminar.use_ben_fil_hab_id,
    this.ben_id
  ).subscribe(() => {
    Swal.close();
    this.cerrarModal();

    // 1) Vuelves a traer los antecedentes (lista de hábitos guardados)
    this.traeAntecedentes();

    // 2) Vuelves a cargar el catálogo de hábitos disponibles
    this.cargarHabitos();
  });
  return;
}

    Swal.close();
    this.cerrarModal();
  }

  cerrarModal() {
    this.modalActual = null;
    this.antecedenteAEliminar = null;
    this.tipoAntecedenteAEliminar = null;
    document.body.classList.remove('modal-open');
  }

  modalCargando() {
    Swal.fire({
      html: `
        <div style="margin: 40px 0;">
          <i class="material-icons" style="color:#171994; font-size: 58px; margin-bottom:25px">schedule</i>
          <h1 style="font-family: Mulish; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Espere por favor...</h1>
        </div>`,
      showConfirmButton: false,
      allowOutsideClick: false
    });
    Swal.showLoading();
  }

  resetVariables() {
    // Limpieza mínima; el form de hábitos ahora es reactivo y no usa habito_nueva
    if (this.consulta) {
      this.alergiaForm.controls['med_con_id'].setValue(this.consulta.med_con_id);
      this.familiaForm.controls['med_con_id'].setValue(this.consulta.med_con_id);
      this.hospitalizacionForm.controls['med_con_id'].setValue(this.consulta.med_con_id);
      this.patologiasForm.controls['med_con_id'].setValue(this.consulta.med_con_id);
      this.medicamentosForm.controls['med_con_id'].setValue(this.consulta.med_con_id);
      this.habitosForm.controls['med_con_id'].setValue(this.consulta.med_con_id);
    }
  }
}
